import React, { useState, useEffect } from 'react';
import {
  StyledModalWrapper,
  StyledModalContent,
  StyledInput,
  StyledModalTitle,
  StyledInputsWrapper,
  StyledInputsGroup,
  StyledButtonsWrapper,
  StyledGrupButtonCheckBoxes,
  StyledTableWrapper,
  StyledErrorMessages,
  StyledSuccessMessages
} from './styleModalDraw';
import Button from '../../core/Buttons';
import { Checkbox } from '../../core/Checkbox';
import { Row, Cell, Table } from '../../core/Table';
import { makeDraw } from '../../../utils/apiNews';
import { Trash } from '../../../../assets/images';
import Icon from '../../core/Icon';

const ModalDraw = ({ onCloseModal, newId }) => {
  const [itemsDraw, setItemsDraw] = useState([]);
  const [itemName, setItemName] = useState('');
  const [itemDrawQuantity, setItemDrawQuantity] = useState(0);
  const [isComment, setIsComment] = useState(false);
  const [isLike, setIsLike] = useState(false);
  const [sendNotification, setSendNotification] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [winners, setWinners] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (itemsDraw.length > 0 && (isComment || isLike)) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [itemsDraw, isComment, isLike]);

  const deleteItem = index => {
    const newItems = itemsDraw.filter((item, i) => i !== index);
    setItemsDraw(newItems);
  };

  return (
    <StyledModalWrapper>
      <StyledModalContent>
        <StyledModalTitle>Es hora del sorteo</StyledModalTitle>
        <StyledInputsWrapper>
          <StyledInputsGroup>
            Qué se sortea
            <StyledInput
              type="text"
              id="itemName"
              name="itemName"
              placeholder="Nombre del item"
              value={itemName}
              onChange={e => setItemName(e)}
            />
          </StyledInputsGroup>
          <StyledInputsGroup>
            Cantidad
            <StyledInput
              type="number"
              id="itemDrawQuantity"
              name="itemDrawQuantity"
              placeholder="Cantidad"
              value={itemDrawQuantity}
              onChange={e => setItemDrawQuantity(e)}
            />
          </StyledInputsGroup>
        </StyledInputsWrapper>
        <StyledGrupButtonCheckBoxes>
          <Button
            onClick={() => {
              setItemsDraw([
                ...itemsDraw,
                { item: itemName, quantity: parseInt(itemDrawQuantity, 10) }
              ]);
              setItemName('');
              setItemDrawQuantity(0);
            }}
            disabled={itemName === '' || itemDrawQuantity <= 0}
          >
            Añadir Premio
          </Button>
          <Checkbox
            label="&nbsp;Comentario"
            onChange={e => setIsComment(e)}
            checked={isComment}
          />
          <Checkbox
            label="&nbsp;Me gusta"
            onChange={e => setIsLike(e)}
            checked={isLike}
          />
          <Checkbox
            label="&nbsp;Notificar"
            onChange={e => setSendNotification(e)}
            checked={sendNotification}
          />
        </StyledGrupButtonCheckBoxes>
        <StyledTableWrapper>
          {!isSuccess ? (
            <Table>
              <Row>
                <Cell tagName="th">Item</Cell>
                <Cell tagName="th">Cantidad</Cell>
              </Row>
              {itemsDraw.map((item, index) => (
                <Row key={item.item}>
                  <Cell>{item.item}</Cell>
                  <Cell>{item.quantity}</Cell>
                  <Cell
                    style={{
                      cursor: 'pointer'
                    }}
                    onClick={() => deleteItem(index)}
                  >
                    <Icon color="dark" size="m" svg={Trash} />
                  </Cell>
                </Row>
              ))}
            </Table>
          ) : (
            <Table>
              <Row>
                <Cell tagName="th">Ganador</Cell>
                <Cell tagName="th">Premio</Cell>
              </Row>
              {winners.map(winner => (
                <Row key={winner.employeeId}>
                  <Cell>{`${winner.name} ${winner.lastname}`}</Cell>
                  <Cell>{winner.prize}</Cell>
                </Row>
              ))}
            </Table>
          )}
        </StyledTableWrapper>
        <StyledButtonsWrapper>
          <Button
            disabled={isDisabled}
            green
            onClick={() =>
              makeDraw(newId, itemsDraw, isLike, isComment, sendNotification)
                .then(response => {
                  setIsDisabled(true);
                  setIsSuccess(true);
                  setIsError(false);
                  setWinners(response);
                })
                .catch(error => {
                  setIsSuccess(false);
                  setIsError(true);
                  setErrorMessage(error.message);
                })
            }
          >
            Sortear
          </Button>
          {isError && <StyledErrorMessages>{errorMessage}</StyledErrorMessages>}
          {isSuccess && (
            <StyledSuccessMessages>
              Sorteo realizado con éxito
            </StyledSuccessMessages>
          )}
          <Button secondary onClick={() => onCloseModal()}>
            Cerrar
          </Button>
        </StyledButtonsWrapper>
      </StyledModalContent>
    </StyledModalWrapper>
  );
};

export default ModalDraw;
